export default "__VITE_ASSET__BpMAltOH__"